export default "__VITE_ASSET__IOQth$lJ__"